module.exports = __webpack_public_path__ + "img/2.f98478b6.png";